module.exports = __webpack_public_path__ + "media/images/escudo_facilita-b31fed9ac43fb284938621231b9f3cca.svg";